import { useLocation } from 'react-router-dom';
import AuthenticationUtil from '../../../util/AuthenticationUtil';
import { TestRouter } from '../../../util/RouterUtil';
import ViewWrapper from '../../ViewWrapper';

// TODO 테스트용 삭제처리
const TestRouterView = () => {
    const auth = AuthenticationUtil.get();
    const pathname = useLocation().pathname;
    return (
        <div className='body-view'>
            <ViewWrapper router={TestRouter} />
        </div>
    );
};

export default TestRouterView;
